import type { GlobalCustomersEndConsumerDto } from '@ori/global-api-client-react';
import type { ChangeEvent } from 'react';

import type { ECustomerTypeSelection, Package } from '../../types';
import type { Frequency } from '../../types/Frequency';

export function setCurrentStep(step: number) {
  return { type: 'setCurrentStep', step } as const;
}

export function setPackage(packageItem?: Package) {
  return { type: 'setPackage', packageItem } as const;
}

export function setCustomerType(customerType: ECustomerTypeSelection) {
  return { type: 'setCustomerType', customerType } as const;
}

export function setExistingCustomer(existingCustomer: GlobalCustomersEndConsumerDto | null) {
  return { type: 'setExistingCustomer', existingCustomer } as const;
}

export function setFrequency(item?: Frequency | null) {
  return { type: 'setFrequency', item } as const;
}

export function setCustomerName({
  currentTarget: { value: firstName },
}: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
  return { type: 'setCustomerName', firstName } as const;
}

export function setCustomerSurname({
  currentTarget: { value: surname },
}: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
  return { type: 'setCustomerSurname', surname } as const;
}

export function goToSummary() {
  return { type: 'goToSummary' } as const;
}

export function stepBack() {
  return { type: 'stepBack' } as const;
}

export function setTermsAndConditions({
  currentTarget: { checked: termsAndConditionsAccepted },
}: ChangeEvent<HTMLInputElement>) {
  return { type: 'setTermsAndConditions', termsAndConditionsAccepted } as const;
}
